import axios from "axios";
import Champ_Formulaire from "../Champs_Formulaire/Champ_Formulaire.class";
import moment from "moment";
import * as list_comite from "../../assets/js/list_comite_05";
import { useBookingStore } from "@/stores/bookingStore";
import PublicService from "@/services/public.service";

/**
 * @classdesc Le coureur d'un utilisateur
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class MyClass
 */
export default class Coureur {
    id;
    id_utilisateur;
    nom_coureur = "";
    document_valide = false;
    champs = {};
    nb_inscriptions_in_base = null;


    /**
     * Creates an instance of Coureur.
     * @constructs
     * @kind function
     * @memberof Coureur
     */
    constructor() { }


    /**
     * Défini le coureur à partir d'un jeu de données
     *
     * @param {Object} data
     * @memberof Coureur
     */
    set(data, from_list = false, omit_pps = false) {
        if (!data) return;
        this.id_utilisateur = data.id_utilisateur;
        this.id = data.id;
        if (from_list) {
            for (let i = 0; i < data.champs.length; i++) {
                let champ = new Champ_Formulaire();
                champ.value = data.champs[i].value;
                champ.nom = data.champs[i].nom_champ;
                if (champ.nom == "numero_pps" && omit_pps) {
                    continue;
                }
                this.champs[champ.nom] = champ;

            }
        }
        else {
            for (const champ of Object.entries(data.champs)) {
                if (champ[1].nom == "numero_pps" && omit_pps) {
                    continue;
                }

                if (this.champs[champ[1].nom]) {
                    // Type de documents
                    if (this.champs[champ[1].nom].type == "select" && champ[1].nom == 'type_document') {
                        let options = this.champs[champ[1].nom].options.split(";");
                        if (options.length > 0) {
                            if (options.includes(champ[1].value)) {
                                this.champs[champ[1].nom].value = champ[1].value;
                            }
                            else {
                                this.champs[champ[1].nom].value = options[0];
                            }
                        }
                        else {
                            this.champs[champ[1].nom].value = champ[1].value;
                        }

                    }
                    // taille tee shirt
                    else if (this.champs[champ[1].nom].type == "select" && champ[1].nom == 'taille_tee_shirt') {
                        let options = this.champs[champ[1].nom].options.split(";");
                        if (options.length > 0) {
                            if (options.includes(champ[1].value)) {
                                this.champs[champ[1].nom].value = champ[1].value;
                            }
                            else {
                                this.champs[champ[1].nom].value = "";
                            }
                        }
                        else {
                            this.champs[champ[1].nom].value = "";
                        }
                    }
                    else {

                        this.champs[champ[1].nom].value = champ[1].value;
                    }

                }

            }
        }
        this.nom_coureur = this.get_nom();

    }

    set_from_initial_commande_inscription(data) {
        if (!data) return;
        let original_coureur = data.inscriptions[0].coureur;
        this.id_utilisateur = original_coureur.id_utilisateur;
        this.id = original_coureur.id;
        for (const champ of Object.entries(original_coureur.champs)) {
            if (this.champs[champ[0]]) {
                this.champs[champ[0]].value = champ[1];
            }
        }
    }

    set_group_default_fields(data) {
        if (!data) return;
        for (const champ of Object.entries(data)) {
            if (this.champs[champ[0]] && this.champs[champ[0]].value == "" && champ[1] != "") {
                this.champs[champ[0]].value = champ[1];
            }
        }
    }

    set_from_fiche_coureur(data) {
        if (!data) return;
        this.id_utilisateur = data.id_utilisateur;
        this.id = data.id;
        for (const champ of Object.entries(data.champs)) {
            this.champs[champ[0]] = champ[1];
        }
    }



    setFromStore(data) {

        if (!data) return;
        this.id_utilisateur = data.id_utilisateur;
        this.id = data.id;
        if (data.equipe_name) {
            this.equipe_name = data.equipe_name;
        }
        if (data.nb_inscriptions_in_base) {
            this.nb_inscriptions_in_base = data.nb_inscriptions_in_base;
        }
        for (const champ of Object.entries(data.champs)) {
            let c = new Champ_Formulaire();
            c.set(champ[1]);
            this.champs[champ[0]] = c;
        }
        this.nom_coureur = this.get_nom();
    }

    clear() {
        this.id = null;
        this.nom_coureur = "";
        this.document_valide = false;
        for (let champ in this.champs) {
            this.champs[champ].value = "";
        }
    }




    /**
     * Construit la liste des champs du coureur
     *
     * @param {*} list_champs
     * @memberof Coureur
     */
    build_list_champs(list_champs) {

        this.remove_unasked_champs(list_champs);
        for (let i = 0; i < list_champs.length; i++) {
            let champ = new Champ_Formulaire();
            champ.set(list_champs[i]);
            if (!this.champs[champ.nom]) {
                this.champs[champ.nom] = champ;
            }
        }
    }



    rebuild_list_champs(list_champs) {
        let rebuilt = {};
        for (let i = 0; i < list_champs.length; i++) {
            let champ = new Champ_Formulaire();
            champ.set(list_champs[i]);
            champ.value = this.champs[champ.nom];
            rebuilt[champ.nom] = champ;
        }
        this.champs = rebuilt;
    }



    /**
     * Supprime les champs non demandés
     *
     * @param {*} list_champs
     * @memberof Coureur
     */
    remove_unasked_champs(list_champs) {
        for (let champ in this.champs) {
            let find = false;
            for (let j = 0; j < list_champs.length; j++) {
                if (list_champs[j].nom == champ) {
                    find = true;
                }
            }
            if (!find) {
                delete this.champs[champ];
            }
        }
    }

    /**
     * Retourne le nom du coureur
     *
     * @return {*} 
     * @memberof Coureur
     */
    get_nom() {
        return this.get_field_value_by_name("nom") + " " + this.get_field_value_by_name("prenom");
    }

    /**
     * Verifie si une limitation est respectée
     *
     * @param {*} type
     * @param {*} valeur
     * @return {*} 
     * @memberof Coureur
     */
    match_limitations(type, valeur, inscription = null, course = "") {
        switch (type) {
            case "date_naissance_min":
                return this.match_limitation_date_naissance_min(valeur);
            case "licence":
                return this.match_limitation_licence();
            case "licence_ffrp":
                return this.match_limitation_licence_ffrp();
            case "filtre_pass_competition":
                return this.match_limitation_filtre_pass_competition();
            case "limitation_sexe":
                return this.match_limitation_sexe(valeur);
            case "licence_comite_05":
                return this.match_limitation_licence_comite_05();
            case "deja_inscrit":
                return this.match_limitation_deja_inscrit(inscription);
            case "reduction_multiparcours":
                return this.match_limitation_reduction_multiparcours(inscription, course);
            default:
                return false;
        }
    }

    /**
     * Verifie si le coureur a une date de naissance supérieure à la date de naissance minimale
     *
     * @param {*} valeur
     * @return {*} 
     * @memberof Coureur
     */
    match_limitation_date_naissance_min(valeur) {

        let naissance = this.get_field_value_by_name("date_naissance");
        if (naissance == "") return false;
        if (valeur == "") return false;
        let naissance_coureur = moment(naissance);
        let naissance_min = moment(valeur);
        return naissance_coureur.isAfter(naissance_min);
    }

    match_limitation_sexe(valeur) {
        let sexe = this.get_field_value_by_name("sexe");
        if (sexe == "") return false;
        return sexe == valeur;
    }
     match_limitation_deja_inscrit(inscription) {
        if (this.get_field_value_by_name("nom") == "" && this.get_field_value_by_name("prenom") == "") return false;
        const nb_inscription_in_base = this.get_nb_inscription_in_base();
        if (nb_inscription_in_base > 0) return true;

        const nb_inscription_locale = this.get_nb_inscription_locale();
        if (nb_inscription_locale <= 1) return false;

        const current_inscription_is_reduced_tarif = this.current_inscription_is_reduced_tarif(inscription);
        if (current_inscription_is_reduced_tarif) return true;

        const has_more_than_one_full_tarif_already_applied = this.has_more_than_one_full_tarif_already_applied();
        if (has_more_than_one_full_tarif_already_applied) return true;
        return false;

    }

    async match_limitation_reduction_multiparcours(inscription, nom_course) {
        // Si le coureur est renseigné on vérifie si il a déjà une inscription en base
        if (this.get_field_value_by_name("nom") != "" && this.get_field_value_by_name("prenom") != "") {
            const nb_inscription_in_base = this.get_nb_inscription_in_base();
            if (nb_inscription_in_base > 0) return true;
        }


        const nb_parcours = this.get_nb_parcours_selected(inscription);
        if (nb_parcours > 1) {
            const count_full_tarif = this.get_count_full_tarif(inscription, nom_course);

            if (count_full_tarif >= 1) return true;
            return false;
        }
        return false;

    }

    get_count_full_tarif(inscription, course) {
        let count = 0;
        let tarifs = inscription.get_all_tarifs_applied(course);
        for (let i = 0; i < tarifs.length; i++) {
            let tarif = tarifs[i];
            if (tarif && (!tarif.has_limitations() || tarif.has_limitations().valeur != 'reduction_multiparcours')) {
                count++;



            }
        }
        return count;

    }

    get_nb_parcours_selected(inscription) {
        let selected_courses = inscription.list_courses.get_selected();
        return selected_courses.length;
    }

    get_nb_inscription_in_base() {
        if (!this.need_to_check_in_base()) {
            return this.nb_inscriptions_in_base.count;
        }
        const coureur_nom = this.get_field_value_by_name("nom");
        const coureur_prenom = this.get_field_value_by_name("prenom");
        const coureur_date_naissance = this.get_field_value_by_name("date_naissance");
        this.nb_inscriptions_in_base.nom = coureur_nom;
        this.nb_inscriptions_in_base.prenom = coureur_prenom;
        this.nb_inscriptions_in_base.date_naissance = coureur_date_naissance;
        this.nb_inscriptions_in_base.count = 0;
        
        this.fetch_inscription_in_base((error, nb_inscriptions) => {
            if (error) {
                console.log(error);
                this.nb_inscriptions_in_base.count = 0;
                return 0;
            }
            else {
                this.nb_inscriptions_in_base.count = nb_inscriptions;
                return nb_inscriptions;
            }
        });
        
    }

    fetch_inscription_in_base(callback) {
        const coureur_nom = this.get_field_value_by_name("nom");
        const coureur_prenom = this.get_field_value_by_name("prenom");
        const coureur_date_naissance = this.get_field_value_by_name("date_naissance");
        const bookingStore = useBookingStore();
        if (!bookingStore.id_module) return 0;
        let params = {
            nom: coureur_nom,
            prenom: coureur_prenom,
            date_naissance: coureur_date_naissance,
            id_module: bookingStore.id_module
        }
        axios.post('public/limitation_tarif/get_nb_inscriptions.php', params)
            .then(response => callback(null,response.data.nb_inscriptions))
            .catch(error => callback(error,0));
    }

    need_to_check_in_base() {
        if (!this.nb_inscriptions_in_base) {
            this.nb_inscriptions_in_base = { count: 100, nom: "", prenom: "", date_naissance: "" };
            return true;
        }
        const coureur_nom = this.get_field_value_by_name("nom");
        const coureur_prenom = this.get_field_value_by_name("prenom");
        const coureur_date_naissance = this.get_field_value_by_name("date_naissance");
        if (coureur_nom == "" || coureur_prenom == "" || coureur_date_naissance == "") return false;
        return coureur_nom != this.nb_inscriptions_in_base.nom || coureur_prenom != this.nb_inscriptions_in_base.prenom || coureur_date_naissance != this.nb_inscriptions_in_base.date_naissance;
    }

    current_inscription_is_reduced_tarif(inscription) {
        if (!inscription) return false;
        let tarif = inscription.get_tarif_applied();
        if (tarif && tarif.has_limitations() && tarif.has_limitations().valeur == 'deja_inscrit') {
            return true;
        }
        return false;
    }

    has_more_than_one_full_tarif_already_applied() {
        const bookingStore = useBookingStore();
        let skipped_first = false;
        if (bookingStore && bookingStore.inscriptions) {
            for (let i = 0; i < bookingStore.inscriptions.length; i++) {
                let inscription = bookingStore.inscriptions[i];
                if (inscription.coureur && inscription.coureur.champs) {
                    let nom = inscription.coureur.get_field_value_by_name("nom");
                    let prenom = inscription.coureur.get_field_value_by_name("prenom");
                    let date_naissance = inscription.coureur.get_field_value_by_name("date_naissance");
                    if (nom == this.get_field_value_by_name("nom") && prenom == this.get_field_value_by_name("prenom") && date_naissance == this.get_field_value_by_name("date_naissance")) {
                        let tarif = inscription.get_tarif_applied();

                        if (tarif && (!tarif.has_limitations() || tarif.has_limitations().valeur != 'deja_inscrit')) {

                            if (!skipped_first) {
                                skipped_first = true;
                                continue;
                            }
                            return true;


                        }

                    }
                }
            }
        }
        return false;
    }

    get_nb_inscription_locale() {
        const bookingStore = useBookingStore();
        let nb_inscription = 0;
        if (bookingStore && bookingStore.inscriptions) {
            for (let i = 0; i < bookingStore.inscriptions.length; i++) {
                let inscription = bookingStore.inscriptions[i];
                if (inscription.coureur && inscription.coureur.champs) {
                    let nom = inscription.coureur.get_field_value_by_name("nom");
                    let prenom = inscription.coureur.get_field_value_by_name("prenom");
                    let date_naissance = inscription.coureur.get_field_value_by_name("date_naissance");
                    if (nom == this.get_field_value_by_name("nom") && prenom == this.get_field_value_by_name("prenom") && date_naissance == this.get_field_value_by_name("date_naissance")) {
                        nb_inscription++;
                    }
                }
            }
        }
        return nb_inscription;
    }




    /**
     * Check if the licence is not empty
     *
     * @return {*} 
     * @memberof Coureur
     */
    match_limitation_licence() {
        let type_document = this.get_field_value_by_name("type_document");
        if (type_document == "Autre licence" || type_document == "Certificat médical" || type_document == 'Document PPS') {
            return false;
        }
        let licence = this.get_field_value_by_name("licence");
        return licence != "";
    }
    match_limitation_licence_ffrp() {
        let type_document = this.get_field_value_by_name("type_document");
        let licence = this.get_field_value_by_name("licence");
        let licence_document = this.get_field_value_by_name("licence_document");
        if (type_document == "Licence" && (licence != "" || licence_document != "")) {
            return true;
        }
        return false;
    }

    match_limitation_licence_comite_05() {
        let licence = this.get_field_value_by_name("licence");
        return licence != "" && list_comite.accepted_comite_05.includes(parseInt(licence));
    }

    match_limitation_filtre_pass_competition() {
        let pass_competition = this.get_field_value_by_name("pass_competition");
        if (typeof pass_competition == "string" && pass_competition == "") {
            return true;
        }
        return pass_competition == false;

    }
    /**
     * Get the value of a field by its name
     *
     * @param {*} field
     * @return {*} 
     * @memberof Coureur
     */
    get_field_value_by_name(field) {
        if (this.champs[field]) {
            return this.champs[field].value;
        }
        return "";
    }
    /**
     * try to fetch the licence from the FFA webservice
     *
     * @param {int} num_ffa
     * @return {*} 
     * @memberof Coureur
     */
    async try_fetch_ffa_webservice(num_ffa) {
        let nom = this.get_field_value_by_name("nom");
        let prenom = this.get_field_value_by_name("prenom");
        let sexe = this.get_field_value_by_name("sexe");
        let date_naissance = this.get_field_value_by_name("date_naissance");
        if (nom != "" && prenom != "" && sexe != "" && date_naissance != "" && parseInt(date_naissance) > 1900) {
            let data = { "nom": nom, "prenom": prenom, "sexe": sexe, "date_naissance": date_naissance, "num_ffa": num_ffa };
            let res = await axios.post("/webservice_FFA/get_licence.php", data);
            if (res.data.error) {
                console.log(res.data.error);
                return await false;
            } else {

                if (res.data.num_licence != "" && this.champs["licence"]) {
                    this.document_valide = true;
                    this.champs["licence"].value = res.data.num_licence;
                }
                else if (res.data.num_licence == "" && this.champs["licence"]) {
                    this.document_valide = false;
                    this.champs["licence"].value = "";
                }
                if (res.data.club != "" && this.champs["club"]) {
                    this.champs["club"].value = res.data.club.replace(/[^a-zA-Z0-9 ]/g, ' ');
                }
            }



            return await true;
        }

    }

    async try_fetch_pps_webservice(num_ffa) {
        let nom = this.get_field_value_by_name("nom");
        let prenom = this.get_field_value_by_name("prenom");
        let sexe = this.get_field_value_by_name("sexe");
        let date_naissance = this.get_field_value_by_name("date_naissance");
        let num_pps = this.get_field_value_by_name("numero_pps");
        if (nom != "" && prenom != "" && sexe != "" && date_naissance != "" && parseInt(date_naissance) > 1900 && num_pps != "") {
            let data = { "nom": nom, "prenom": prenom, "sexe": sexe, "date_naissance": date_naissance, "num_ffa": num_ffa, "num_pps": num_pps };
            let res = await axios.post("/webservice_FFA/get_pps.php", data);
            if (res.data && res.data.valid_ffa) {

                this.document_valide = true;
            }
            else {
                this.document_valide = false;
            }
            return res.data;
        }
        return false;
    }

    async try_fetch_ffr_webservice(numero_licence_field) {
        this.document_valide = false;
        let nom = this.get_field_value_by_name("nom");
        let prenom = this.get_field_value_by_name("prenom");
        let sexe = this.get_field_value_by_name("sexe");
        let date_naissance = this.get_field_value_by_name("date_naissance");
        let numero_licence_ffr = this.get_field_value_by_name(numero_licence_field);
        let type_inscription_ffr = this.get_field_value_by_name("type_inscription_ffr") ? this.get_field_value_by_name("type_inscription_ffr") : "Licencié compétition FFRandonnée";
        if (nom != "" && prenom != "" && sexe != "" && date_naissance != "" && parseInt(date_naissance) > 1900) {

            let data = { "nom": nom, "prenom": prenom, "sexe": sexe, "date_naissance": date_naissance, "numero_licence_ffr": numero_licence_ffr, "type_inscription_ffr": type_inscription_ffr };
            let res = await axios.post("/webservice_FFR/get_licence.php", data);
            if (res.data.error) {
                console.log(res.data.error);
                this.document_valide = false;
                return await false;
            } else {
                if (res.data.valid) {
                    this.document_valide = true;
                }
                return res;
            }
        }
    }



    validate() {
        return true;
    }

    unvalidate_document() {
        this.document_valide = false;
    }
    validate_document() {
        this.document_valide = true;
    }

    /**
     * Checks if the 'champs' object has any properties.
     *
     * @returns {boolean} True if 'champs' has one or more properties, otherwise false.
     */
    has_champs() {
        return Object.keys(this.champs).length > 0;
    }

    /**
     * Checks if the person is a minor (under 18 years old).
     *
     * @returns {boolean} - Returns true if the person is a minor, otherwise false.
     */
    is_mineur() {
        if (!this.champs) {
            return false;
        }
        if (this.champs.date_naissance && this.champs.date_naissance.value) {
            let date_naissance = moment(this.champs.date_naissance.value);
            let date_now = moment();
            let age = date_now.diff(date_naissance, "years");
            if (age < 18) {
                return true;
            }
        }
        return false;
    }

    /**
     * Retrieves a list of fields that meet certain conditions.
     * 
     * This method iterates over the `champs` object and checks if each field meets the specified conditions.
     * For the 'certificat_medical_ffr' field, it has a special condition where it is only included if the runner is not a minor.
     * 
     * @returns {Object} An object containing the fields that meet the conditions.
     */
    get_list_champs_meet_conditions() {
        let champs_met = {};
        for (const [key, value] of Object.entries(this.champs)) {
            
            // Particularité pour FFRP : si le coureur est mineur, on ne demande pas de certificat médical
            if (key == 'cm_ffr_6_mois' || key == 'cm_ffr_3_ans') {
                if (this.condition_meet(value) && !this.is_mineur()) {
                    champs_met[key] = value;
                }
            }
            // Cas normal
            else {
                if (this.condition_meet(value)) {
                    champs_met[key] = value;
                }
            }

        }
        return champs_met;
    }


    /**
     * Checks if the given condition is met for the specified field.
     */
    condition_meet(current) {
        let current_label_condition = current.condition_nom;
        let current_label_condition_2 = current.condition_nom_2;
        // If there is no condition, return true
        if ((!current_label_condition || current_label_condition === "")) {
            return true;
        }
        let champ_condition_1 = Object.values(this.champs).find(champ => champ.nom == current_label_condition);
        let champ_condition_2 = Object.values(this.champs).find(champ => champ.nom == current_label_condition_2);
        let first_condition_met = true;
        let second_condition_met = true;
        if (champ_condition_1) {
            first_condition_met = current.condition_met(champ_condition_1.value);
        }
        if (champ_condition_2) {
            second_condition_met = current.condition_met(champ_condition_2.value, 2);
        }
        if (!first_condition_met || !second_condition_met) {
            this.on_condition_not_meet(current);
            return false;
        }
        return true;
    }

    


    /**
     * Clears the value of the specified field if the condition is not met.
     *
     * @param {Object} champ - The field object containing the name of the field.
     * @param {string} champ.nom - The name of the field.
     */
    on_condition_not_meet(champ) {
        if (!this.champs[champ.nom]) {
            return;
        }
        this.champs[champ.nom].value = "";
    }

    /**
     * Checks if the runner's address is in a French commune.
     *
     * @returns {boolean} True if the country is France (FRA) and the postal code (cp) has a length of 5, otherwise false.
     */
    is_commune_francaise() {
        return this.champs.pays && this.champs.pays.value == "FRA" && this.champs.cp && this.champs.cp.value.length == 5;
    }

    async checkIncoherence() {
        const nom = this.get_field_value_by_name("nom");
        const prenom = this.get_field_value_by_name("prenom");
        const sexe = this.get_field_value_by_name("sexe");
        let response = await PublicService.checkIncoherence(nom, prenom, sexe);
        if (!response.nom_valide || !response.prenom_valide || !response.sexe_valide) {
            return response;
        }
        return false;
    }

    getLyraCommandeInfos() {
        let infos = {};
        infos.id = this.id;
        infos.id_utilisateur = this.id_utilisateur;
        infos.champs = this.getChampsForLyraCommandeInfos();
        infos.document_valide = this.document_valide;
        return infos;
    }

    getChampsForLyraCommandeInfos() {
        let list_champs = {};
        for (const [key, value] of Object.entries(this.champs)) {
            list_champs[key] = value.value;
        }
        return list_champs;
    }

}